import Vue from 'vue';
import Element from 'element-ui';
import App from './App.vue';
import router from './router';
import Storage from 'vue-ls'
import VueClipboard from 'vue-clipboard2'
import TableQgm from '@qtt/wlx-element-ui/lib/table-qgm';
import TableColumnQgm from '@qtt/wlx-element-ui/lib/table-column';
import 'element-ui/lib/theme-chalk/index.css';
import '@qtt/wlx-element-ui/lib/theme-chalk/index.css';

import 'element-ui/lib/theme-chalk/index.css';
// import '@qtt/wlx-element-ui/lib/theme-chalk/index.css';

const options = {
  namespace: 'qumeng__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local', //storage name session, local, memory
}

Vue.config.productionTip = false;

Vue.use(Element, { size: 'middle' });
Vue.use(Storage, options);
Vue.use(VueClipboard);
Vue.use(TableQgm);
Vue.use(TableColumnQgm);

// Object.keys(directives).forEach((name) => {
//   Vue.directive(name, directives[name]);
// });

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
